<div class="row">

    <div
    [ngClass]="{'col-12': simple, 'col-12 col-xxl-6': !simple}"
    >

        <div class="row">
            <div class="col-12 d-flex d-flex justify-content-between mb-3" *ngIf="_shipment && !simple">
                <button (click)="save().subscribe()" type="button" class="btn  btn-primary"
                        [disabled]="saving || deleting || completing">
                    {{ saving ? 'Gemmer...' : 'Gem' }}
                </button>

                <button *ngIf="showBackButton"
                        (click)="save(true).subscribe()" type="button" class="btn  btn-primary"
                        [disabled]="saving || deleting || completing">
                    {{ saving ? 'Gemmer...' : 'Gem og tilbage' }}
                </button>

                <div class="d-flex gap-1">
                    <button
                            *ngIf="!isReturn"
                            (click)="copy(false)" type="button" class="btn  btn-warning"
                            [disabled]="saving || deleting || completing">
                        Kopi
                    </button>
                    <button
                            *ngIf="!isReturn"
                            (click)="copy(true)" type="button" class="btn  btn-warning"
                            [disabled]="saving || deleting || completing">
                        Kopi til retur
                    </button>
                </div>
                <button
                        *ngIf="_shipment.is_return_shipment && _shipment.shipment_packages.length === 0"
                        (click)="deleteShipment()" type="button" class="btn  btn-danger"
                        [disabled]="saving || deleting || completing">
                    Slet
                </button>
            </div>
            <div class="col-4 col-xxl-5 " *ngIf="_shipment">
                <div class="row">

                    <ng-container *ngIf="!simple">

                        <!-- shipping_date -->
                        <div class="col-6">Leverings Dato:</div>

                        <div class="col-6 pb-2">
                            <app-date-time-picker [(date)]="_shipment.shipping_date"
                                                  [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                                  [inputSmall]="true"
                                                  id="shipment-shipping-date"
                                                  type="text"
                                                  name="shipment-shipping-date"></app-date-time-picker>
                        </div>

                        <div class="col-6">Ordre Dato:</div>

                        <div class="col-6 pb-2">
                            <input type="text" readonly class="form-control form-control-sm"
                                   [value]="_shipment.order_date.format('DD-MM-YYYY')"
                                   *ngIf="_shipment.order_date && _shipment.order_date.isValid">
                        </div>

                    </ng-container>
                    <div class="col-12" style="padding: 12px 15px;">
                        <div class="form-group">
                            <label for="shipment-edit-form-internal_comment">Kundens kommentar / Kommentar til
                                chauffør</label>
                            <textarea id="shipment-edit-form-comment" [(ngModel)]="_shipment.comments"
                                      class="form-control"></textarea>

                            <div class="form-text">Kommentar til fragtmand / chauffør, printes ikke på label.</div>

                        </div>
                    </div>
                    <div class="col-12" style="padding: 12px 15px;">
                        <div class="form-group">
                            <label for="shipment-edit-form-internal_comment">Intern kommentar</label>
                            <textarea id="shipment-edit-form-internal_comment" [(ngModel)]="_shipment.internal_comment"
                                      class="form-control"></textarea>

                            <div class="form-text">Intern kommentar, kun synlig for 10-4</div>

                        </div>
                    </div>
                    <div class="col-12" style="padding: 12px 15px;">
                        <div class="form-group">
                            <label for="shipment-edit-form-additional_reference">Alternativ reference</label>
                            <textarea id="shipment-edit-form-additional_reference"
                                      [(ngModel)]="_shipment.additional_reference"
                                      class="form-control"></textarea>
                            <div class="form-text">Printes på label</div>

                        </div>
                    </div>
                    <div class="col-12" style="padding: 12px 15px;">
                        <div class="form-group">
                            <label for="shipment-edit-form-pickup_instructions">Kommentar til afhenter</label>
                            <textarea id="shipment-edit-form-pickup_instructions"
                                      [(ngModel)]="_shipment.pickup_instructions"
                                      class="form-control"></textarea>
                            <div class="form-text">Bruges kun ved returforsendelse med afhenting</div>

                        </div>
                    </div>


                    <ng-container *ngIf="!simple">

                        <div class="col-12" style="padding: 12px 15px;">
                            <div class="form-group">
                                <label>Afdeling</label>
                                <input type="text" [(ngModel)]="_shipment.branch"
                                       class="form-control text-body text-dark" disabled>
                            </div>
                        </div>

                        <!-- route_id -->
                        <div class="col-12 form-group">
                            <label class="control-label" i18n>Driver</label>
                            <span *ngIf="saving" class="text-muted" style="margin-left: 10px;" i18n>Saving...</span>
                            <select class="form-control  form-control-sm"
                                    name="shipment-route-id"
                                    [(ngModel)]="_shipment.shipment_route_id"
                                    [disabled]="saving">
                                <option i18n [value]="null">No Driver assigned</option>
                                <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">
                                    <option [value]="shipmentRoute.id">{{ shipmentRoute.name }} {{ shipmentRoute.trip }}
                                        ({{ shipmentRoute.branch }})
                                    </option>
                                </ng-template>
                            </select>
                        </div>

                        <div class="col-12 form-group">
                            <label class="control-label" i18n>Dropoff time</label>
                            <select class="form-control  form-control-sm" name="shipment-dropoff-time"
                                    [(ngModel)]="_shipment.dropoff_time">
                                <option [value]="5">5 min</option>
                                <option [value]="10">10 min</option>
                                <option [value]="20">20 min</option>
                                <option [value]="30">30 min</option>
                                <option [value]="45">45 min</option>
                                <option [value]="60">60 min</option>
                                <option [value]="90">90 min</option>
                            </select>
                        </div>

                        <div class="col-12">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox"
                                       [checked]="_shipment.shipment_priority===9999"
                                       name="shipment_priority"
                                       value="9999"
                                       (change)="changePriority($event)" role="switch" id="flexSwitchCheckDefault">
                                <label class="form-check-label" for="flexSwitchCheckDefault">Haster</label>
                            </div>
                        </div>

                    </ng-container>

                    <div class="col-12" *ngIf="showDiagram">
                        <app-shipment-diagram *ngIf="_shipment" [shipment]="_shipment"
                                              [dev]="false"></app-shipment-diagram>
                    </div>
                </div>
            </div>
            <div class="col-4 col-xxl-3">

                <div class="row">
                    <div class="col-12 mb-3">

                        <app-edit-adresses-form [_shipment]="_shipment" [simple]="simple" *ngIf="simple"
                                                (stuffChanged)="save().subscribe()"
                                                [saving]="saving"></app-edit-adresses-form>

                        <ul class="list-group" *ngIf="!simple">

                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">web</span> <span
                                    class="h5">{{ _shipment.order_reference ? _shipment.order_reference : '-' }}</span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">nota</span> <span
                                    class="h5">{{ _shipment.nota_number }}</span>

                                <img
                                        class="img-fluid"
                                        *ngIf="imageBase64"
                                     [src]="imageBase64 ? ('data:image/png;base64,' +imageBase64) : ''"/>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">Sælger</span> <span
                                    class="h5">{{ _shipment.contact_ref ? _shipment.contact_ref : '-' }}</span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">rekv.</span> <span
                                    class="h5">{{ _shipment.rekv_number ? _shipment.rekv_number : '-' }}</span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">intern forsendelse</span> <span
                                    class="h5">{{ _shipment.is_internal_shipment ? 'Ja' : '-' }}</span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start">
                                <span class="badge  text-bg-secondary">placering</span> <span
                                    class="h5">{{ _shipment.placement ? _shipment.placement : '-' }}</span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"><span
                                    class="badge  text-bg-secondary">Status</span>
                                <app-shipment-status-widget [status]="_shipment.shipment_status"
                                                            [label]="_shipment.formattedStatus()"
                                                            [showLabel]="true"></app-shipment-status-widget>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"><span
                                    class="badge  text-bg-secondary">User</span>
                                <ng-container>

                  <span class="h5">{{ _shipment?.user?.name ? _shipment.user.name : '-' }}
                    </span>
                                </ng-container>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"><span
                                    class="badge  text-bg-secondary">Provider</span>
                                <ng-container>
                                    <span class="h5">{{ _shipment.provider }}</span>
                                </ng-container>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"><span
                                    class="badge  text-bg-secondary">Vægt</span>
                                <ng-container>
                                    <span class="h5"
                                          [ngClass]="{'text-danger': _shipment.weight_warning}">{{ _shipment.weight_sum }}
                                        <i class="fa-solid fa-diamond-exclamation" *ngIf="_shipment.weight_warning"></i></span>
                                </ng-container>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"
                                *ngIf="_shipment.parent_shipment">
                                <span class="badge  text-bg-secondary">Parent shipment</span>
                                <span class="h5">
                                <a [routerLink]="'/shipment/'+ _shipment.parent_shipment?.id">
                                <span>
                                    {{ _shipment.parent_shipment?.nota_number }}</span>
                                    <span> - {{ _shipment.parent_shipment?.branch }}</span>
                                </a>
                            </span>
                            </li>
                            <li class="list-group-item d-flex flex-column align-items-start"
                                *ngIf="_shipment.child_shipments && _shipment.child_shipments.length > 0">
                                <span class="badge  text-bg-secondary">Child shipments</span>
                                <span class="h5" *ngFor="let child of _shipment.child_shipments">
                                <a [routerLink]="'/shipment/' + child.id">
                                <span>
                                    {{ child.nota_number }}</span>
                                    <span> - {{ child.branch }}</span>
                                </a>
                            </span>
                            </li>

                            <li class="list-group-item d-flex flex-column align-items-start"
                                *ngIf="_shipment.group_child_shipments && _shipment.group_child_shipments.length > 0">

                                <span class="badge  text-bg-secondary">Indeholder varer fra:</span>

                                <span class="h5" *ngFor="let child of _shipment.group_child_shipments">
                                <a [routerLink]="'/shipment/' + child.id">
                                <span>
                                    {{ child.nota_number }}</span>
                                    <span> - {{ child.branch }}</span>
                                </a>

                                </span>
                            </li>


                            <li class="list-group-item d-flex flex-column align-items-start"
                                *ngIf="_shipment.group_parent_shipment">
                                <span class="badge  text-bg-secondary">Sendt med</span>
                                <span class="h5">
                                <a [routerLink]="'/shipment/'+ _shipment.group_parent_shipment?.id">
                                <span>
                                    {{ _shipment.group_parent_shipment?.nota_number }}</span>
                                    <span> - {{ _shipment.group_parent_shipment?.branch }}</span>
                                </a>
                            </span>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-4 ">
                <div class="row">
                    <div class="col-12 form-group" *ngIf="simple">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                   id="is_return_shipment"
                                   name="is_return_shipment"
                                   [(ngModel)]="_shipment.is_return_shipment"
                                   (change)="save().subscribe()"
                                   [disabled]="saving || deleting || completing">
                            <label class="form-check-label" for="is_return_shipment" i18n>Retur forsendelse</label>
                        </div>
                    </div>
                    <div class="col-12 form-group">
                        <label class="control-label" i18n>Carrier</label>
                        <span *ngIf="saving" class="text-muted" style="margin-left: 10px;" i18n>Saving...</span>
                        <select class="form-control  form-control-sm mb-3"
                                name="shipment-route-id"
                                (ngModelChange)="changeCarrier($event)"
                                [ngModel]="_shipment.carrier_code"
                                [disabled]="saving">
                            <option i18n [value]="null">No carrier assigned</option>
                            <ng-template ngFor let-carrier [ngForOf]="carriers">
                                <option [value]="carrier.id">{{ carrier.name }}
                                </option>
                            </ng-template>
                        </select>
                    </div>
                </div>

                <p *ngIf="_shipment.carrier_logo">
                    <img [src]="environment.assetBase +'/assets/img/'+_shipment.carrier_logo" class="img-fluid">
                </p>

                <div class="row">
                    <div class="col-12 form-group">
                        <div *ngFor="let service of validServices">
                            <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" [checked]="service._selected"
                                       name="service_{{ service.service_code }}"
                                       [disabled]="saving || deleting || completing"
                                       (change)="changeService(service)" role="switch"
                                       id="service_{{ service.service_code }}">
                                <label class="form-check-label"
                                       for="service_{{ service.service_code }}">{{ service.service_name }}</label>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="d-flex gap-3 mb-3">
                    <button
                            *ngIf="!isReturn"
                            (click)="addPackage(false)" type="button" class="btn  btn-primary  btn-sm  my-3"
                            [disabled]="saving || deleting || completing">Opret pakke
                    </button>
                    <button
                            *ngIf="isReturn"
                            (click)="addPackage(true)" type="button" class="btn  btn-primary  btn-sm  my-3"
                            [disabled]="saving || deleting || completing">Opret retur
                    </button>
                </div>

                <ng-container *ngIf="!simple">
                    <app-shipment-address [address]="_shipment?.shipment_address"
                                          [label]="'Modtager Adresse'"></app-shipment-address>
                    <app-shipment-address [address]="_shipment?.sender_address"
                                          [label]="'Afsender Adresse'"></app-shipment-address>
                    <ng-container *ngIf="_shipment?.pickup_address">
                        <app-shipment-address [address]="_shipment?.pickup_address"
                                              [label]="'Afhenter adresse'"></app-shipment-address>
                    </ng-container>
                    <ng-container *ngIf="_shipment.isDroppoint()">
                        <app-shipment-address [address]="_shipment?.droppoint_address"
                                              [label]="'Droppoint'"></app-shipment-address>
                    </ng-container>
                    <p>
                        <a href="javascript:" (click)="editLocation()"><i class="fas fa-pencil-alt"></i> <span i18n> Ret adresser</span></a><br/>

                        <ng-container *ngIf="_shipment.shipment_address">
                            <a href="https://www.google.com/maps/@?api=1&map_action=pano&viewpoint={{_shipment.shipment_address.y}},{{_shipment.shipment_address.x}}"
                               *ngIf="!_shipment.has_invalid_coords"
                               target="_blank"><i class="fas fa-map-signs"></i> Street View</a>
                            <span *ngIf="_shipment.has_invalid_coords" class="text-danger">Ingen coordinater</span>
                        </ng-container>
                    </p>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="col-12 col-xxl-6">
        <ng-container *ngIf="!simple">

            <h4>Ændre status</h4>
            <div class="d-flex align-items-center" style="column-gap: 0.25rem">
                <button
                        *ngIf="_shipment.carrier_code ==='999' && !ShipmentsService.getBit(_shipment.delivery_progress, shipmentsService.deliveryBitMasks.pakket)"
                        (click)="quickAction('packing_completed')" class="btn btn-success">Klar til afhentning
                </button>
                <button
                        *ngIf="_shipment.carrier_code ==='999' && !ShipmentsService.getBit(_shipment.delivery_progress, shipmentsService.deliveryBitMasks.afhentet)"
                        (click)="quickAction('handed_out')" class="btn btn-primary">Afhentet
                </button>

                <button
                        *ngIf="_shipment.carrier_code !=='999' && !ShipmentsService.getBit(_shipment.delivery_progress, shipmentsService.deliveryBitMasks.hentetAfFragtUdbyder)"
                        (click)="quickAction('shipped')" class="btn btn-primary">Afsendt
                    <fa-icon [icon]="faMobileAlt"></fa-icon>
                </button>
                <button
                        *ngIf="_shipment.carrier_code !=='999' && !ShipmentsService.getBit(_shipment.delivery_progress, shipmentsService.deliveryBitMasks.modtagetAfKunde)"
                        (click)="quickAction('complete')" class="btn btn-primary">Afleveret hos kunde
                    <fa-icon [icon]="faMobileAlt"></fa-icon>
                </button>
                <button
                        *ngIf="_shipment.carrier_code !=='999' && !ShipmentsService.getBit(_shipment.delivery_progress, shipmentsService.deliveryBitMasks.modtagetAfKunde)"
                        (click)="quickAction('complete', true)" class="btn btn-primary">Afleveret hos kunde (ingen SMS)
                </button>

                <button (click)="startCreateNewEvent()" class="btn btn-success btn-sm" i18n>New event</button>
                <!-- <button (click)="flashShipment()" class="btn btn-success" i18n>Flash Shipment</button> -->
                <button (click)="resetState()" class="btn btn-link btn-sm" i18n>Nulstil forsendelse</button>
            </div>

            <nav ngbNav class="nav-tabs mt-3" #tabs="ngbNav"
                 [activeId]="isReturn ? 'packages' : 'events'"
            >
                <ng-container ngbNavItem [ngbNavItem]="'events'">
                    <a ngbNavLink>Beskeder <span
                            *ngIf="_shipment.shipment_events">({{ _shipment.shipment_events.length }})</span></a>
                    <ng-template ngbNavContent>
                        <div class="border border-light mb-3">
                            <table class="table table-sm table-striped m-0">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th i18n>User</th>
                                    <th>Status</th>
                                    <th>Besked</th>
                                    <th>Tidspunkt</th>
                                    <th style="width: 150px;">Billede</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>

                                <tbody>
                                <ng-template ngFor let-shipmentEvent [ngForOf]="_shipment.shipment_events">
                                    <tr>
                                        <td>
                                            <i class="fas fa-box" *ngIf="shipmentEvent.model==='Shipments'"></i>
                                            <i class="fas fa-wrench"
                                               *ngIf="shipmentEvent.model==='ShipmentProductLines'"></i>
                                        </td>
                                        <td>{{ shipmentEvent?.user?.name }}</td>
                                        <td>{{ shipmentEvent.shipment_status_formatted }}</td>
                                        <td>{{ shipmentEvent.status_text }}</td>
                                        <td class="text-nowrap">{{ shipmentEvent.date.format('DD-MM-YYYY HH:mm') }}</td>
                                        <td>
                                            <ng-container
                                                    *ngIf="shipmentEvent.image_links && shipmentEvent.image_links.length > 0">
                                                <ng-template ngFor let-image_link [ngForOf]="shipmentEvent.image_links">
                                                    <ng-container *ngIf="image_link.preview_url">
                                                        <a (click)="openImageLink(image_link)">
                                                            <img [src]="image_link?.preview_url"
                                                                 style="width: 150px; height: auto"
                                                                 class="img-fluid">
                                                        </a><br/>
                                                    </ng-container>
                                                </ng-template>
                                            </ng-container>
                                            <p *ngIf="!shipmentEvent.image_links" class="text-muted">Intet billede</p>
                                        </td>
                                        <td><a
                                                *ngIf="shipmentEvent.x && shipmentEvent.y"
                                                [href]="'https://www.google.com/maps/search/?api=1&query=' +shipmentEvent.x +','+ shipmentEvent.y"
                                                target="_blank"><i class="fas fa-map-pin"></i></a>
                                        </td>
                                        <td>
                                            <a href="javascript:" (click)="openForwardModal(shipmentEvent)">
                                                <i class="fas fa-share"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container [ngbNavItem]="'packages'">
                    <a ngbNavLink>Pakker <span
                            *ngIf="_shipment.shipment_packages">({{ _shipment.shipment_packages.length }})</span></a>
                    <ng-template ngbNavContent>
                        <div class="border border-light mb-3">
                            <table class="table table-sm table-striped m-0">
                                <thead>
                                <tr>
                                    <th i18n>Created</th>
                                    <th i18n>Afdeling</th>
                                    <th i18n>User</th>
                                    <th i18n>Tracking</th>
                                    <th i18n>Weight</th>
                                    <th i18n>Packaging</th>
                                    <th i18n>Price</th>
                                    <th i18n>Products</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <ng-template ngFor let-shipmentPackage [ngForOf]="_shipment.shipment_packages">
                                    <tr [class]="shipmentPackage.deleted ? 'text-decoration-line-through table-danger' : ''">
                                        <td>{{ shipmentPackage.created.format('DD.MM.YYYY HH:mm') }}
                                            <span *ngIf="shipmentPackage.deleted"><br>Slettet: {{ shipmentPackage.deleted.format('DD.MM.YYYY HH:mm') }}</span>
                                        </td>

                                        <td>
                                            <ng-container *ngIf="!shipmentPackage.shipment">
                                                -
                                            </ng-container>
                                            <ng-container *ngIf="shipmentPackage.shipment">
                                                <a [routerLink]="'/shipment/'+ shipmentPackage.shipment.id">
                                                    {{ shipmentPackage.shipment.nota_number }}
                                                    - {{ shipmentPackage.shipment.branch }}
                                                </a>
                                                <br>
                                            </ng-container>
                                        </td>
                                        <td> {{ shipmentPackage?.user?.name }} @
                                            {{ shipmentPackage?.user?.getCustomFieldValue('branch') }}
                                        </td>
                                        <td>
                                            <ng-container *ngIf="shipmentPackage.tracking_link">
                                                <a [href]="shipmentPackage.tracking_link"
                                                   target="_blank">{{ shipmentPackage.tracking_number }}
                                                    <fa-icon [icon]="faShare"></fa-icon>
                                                </a>
                                                <br>
                                            </ng-container>

                                            <ng-container *ngIf="shipmentPackage.tracking_number">
                                                <span>Fragtbrev: </span>
                                                <code>{{ shipmentPackage.tracking_number }}</code>
                                            </ng-container>

                                            <ng-container *ngIf="shipmentPackage.tracking_links">
                                                <br>
                                                <span>Labels: </span>
                                                <code *ngFor="let extraTracking of shipmentPackage.tracking_links">
                                                    <a [href]="extraTracking.link"
                                                       target="_blank">{{ extraTracking.label }}
                                                        <fa-icon [icon]="faShare"></fa-icon>
                                                    </a>
                                                </code>
                                            </ng-container>
                                        </td>
                                        <td>
                                <span *ngIf="shipmentPackage.weight">
                                {{ shipmentPackage.weight | number:'1.0-2' }} kg
                                </span>
                                        </td>
                                        <td>
                                            {{ shipmentPackage.package_type }}
                                        </td>
                                        <td>
                                <span class="d-flex flex-column" *ngIf="shipmentPackage.carrier_code==='10'">
                                    <span>{{ shipmentPackage.price | currency:'DKK':true:'1.2-2' }} {{ shipmentPackage.invoice_number ? '(' + shipmentPackage.invoice_number + ')' : '' }}
                                    </span>
                                <small class="text-muted"
                                       *ngIf="shipmentPackage.price">Pris inkl. afgifter, ekskl. moms</small>
                                <button *ngIf="!shipmentPackage.price"
                                        (click)="fetchPrice(shipmentPackage)" class="btn btn-secondary btm-sm"
                                        [disabled]="saving || deleting || completing">
                                    <fa-icon [icon]="faDollarSign"></fa-icon>
                                    Hent priser
                                </button>
                                </span>
                                        </td>
                                        <td>
                                            <span [innerHTML]="shipmentPackage.getDescription() | newlineToBr"></span>

                                            <ul class="list-unstyled" *ngIf="!shipmentPackage.getDescription()">
                                                <ng-template ngFor let-product
                                                             [ngForOf]="shipmentPackage.getProducts(_shipment)">
                                                    <li class="mb-3">
                                                        <b>{{ product['amount'] }} x</b>

                                                        <ng-container *ngIf="product['shipmentProductLine']">
                                                            {{ product['shipmentProductLine'].product_text_1 }}<br>
                                                            {{ product['shipmentProductLine'].product_text_2 }}<br>
                                                            {{ product['shipmentProductLine'].product_text_3 }}
                                                        </ng-container>

                                                        <ng-container *ngIf="!product['shipmentProductLine']">
                                                            <b>Produkt: {{ product['name'] }}</b>
                                                        </ng-container>
                                                    </li>
                                                </ng-template>
                                            </ul>
                                        </td>

                                        <td>
                                            <button (click)="deletePackage(shipmentPackage)" class="btn btn-link"
                                                    [disabled]="saving || deleting || completing">
                                                <fa-icon [icon]="faTrash"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container [ngbNavItem]="'products'">
                    <a ngbNavLink>Produkter <span
                            *ngIf="_shipment.shipment_product_lines">({{ _shipment.shipment_product_lines.length }})</span></a>
                    <ng-template ngbNavContent>

                        <button (click)="addProductLine()" type="button" class="btn  btn-primary  btn-sm  my-3"
                                [disabled]="saving || deleting || completing">Add productline
                        </button>

                        <div class="border border-light mb-3">
                            <table class="table table-sm table-striped m-0">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th>#</th>
                                    <th>Status</th>
                                    <th i18n>Stock</th>
                                    <th>PO#</th>
                                    <th>Note</th>
                                    <th>TUN</th>
                                    <th>Tekst</th>
                                    <th class="text-end">Antal</th>
                                    <th class="text-end">Vægt</th>
                                </tr>
                                </thead>

                                <tbody>
                                <ng-template ngFor let-product_line [ngForOf]="_shipment.shipment_product_lines"
                                             let-i="index">
                                    <tr app-shipment-product-line [inlineEdit]="false" [shipment]="_shipment"
                                        [product_line]="product_line" [i]="i"></tr>
                                    <tr app-shipment-product-line [actions]="true" [shipment]="_shipment"
                                        [product_line]="product_line" [i]="i"></tr>
                                </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </ng-template>
                </ng-container>
            </nav>

            <div [ngbNavOutlet]="tabs"></div>

        </ng-container>
    </div>
</div>
